var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 14,
  fill: "#C6FFD6",
  fillOpacity: 0.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00A32E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.75,
  strokeWidth: 1.5,
  d: "M25.5 29.25v-.75A4.5 4.5 0 0 0 21 24h-6a4.5 4.5 0 0 0-4.5 4.5v.75M22.5 15a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m9 3c0 7.456-6.044 13.5-13.5 13.5S4.5 25.456 4.5 18 10.544 4.5 18 4.5 31.5 10.544 31.5 18"
})));
export { SvgUserProfile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTQiIGZpbGw9IiNDNkZGRDYiIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGQ9Ik0yNS41IDI5LjI1VjI4LjVDMjUuNSAyNi4wMTQ3IDIzLjQ4NTMgMjQgMjEgMjRIMTVDMTIuNTE0NyAyNCAxMC41IDI2LjAxNDcgMTAuNSAyOC41VjI5LjI1TTIyLjUgMTVDMjIuNSAxNy40ODUzIDIwLjQ4NTMgMTkuNSAxOCAxOS41QzE1LjUxNDcgMTkuNSAxMy41IDE3LjQ4NTMgMTMuNSAxNUMxMy41IDEyLjUxNDcgMTUuNTE0NyAxMC41IDE4IDEwLjVDMjAuNDg1MyAxMC41IDIyLjUgMTIuNTE0NyAyMi41IDE1Wk0zMS41IDE4QzMxLjUgMjUuNDU1OCAyNS40NTU4IDMxLjUgMTggMzEuNUMxMC41NDQyIDMxLjUgNC41IDI1LjQ1NTggNC41IDE4QzQuNSAxMC41NDQyIDEwLjU0NDIgNC41IDE4IDQuNUMyNS40NTU4IDQuNSAzMS41IDEwLjU0NDIgMzEuNSAxOFoiIHN0cm9rZT0iIzAwQTMyRSIgc3Ryb2tlLW9wYWNpdHk9IjAuNzUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";